import { Typography, Box, TextField, Grid, Paper, MenuItem } from "@mui/material";
import { useProject } from "../../context/ProjectContext.tsx";
import PageLayout from '../../components/PageLayout.tsx';

const ProjectPage = () => {
  const { project, setProject } = useProject();

  const handleCompanyChange = (field: string, value: string) => {
    setProject({ ...project, company: { ...project.company, [field]: value } });
  };

  return (
    <PageLayout
      title="Projekt"
      backText="Zurück zum HowTo"
      backTarget="/"
      nextText="Weiter zur Mechanik"
      nextTarget="/mechanics"
    >
      <Paper sx={{ p: 3, mb: 6 }}>
        <Grid container spacing={2}>
          <Grid size={6}>
            <TextField
              required
              fullWidth
              label="Projektname"
              value={project.name}
              error={project.name === ""}
              onChange={e => setProject({ ...project, name: e.target.value })}
            />
          </Grid>
          <Grid size={6}>
            <TextField
              fullWidth
              select
              label="Eingabe Bediener erforderlich"
              value={ project.ask_for_user === true ? "Ja" : "Nein" }
              onChange={e => setProject({ ...project, ask_for_user: e.target.value === "Ja" ? true : false })}
            >
              {["Ja", "Nein"].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid size={6}>
            <TextField
              fullWidth
              label="QDE Artikelnummer"
              value={project.article_number ?? ""}
              onChange={e => setProject({ ...project, article_number: e.target.value })}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              fullWidth
              multiline
              minRows={4}
              label="Anmerkungen und Besonderheiten"
              value={project.notes ?? ""}
              onChange={e => setProject({ ...project, notes: e.target.value })}
            />
          </Grid>
        </Grid>
      </Paper>
      <Paper sx={{ p: 3, mb: 6 }}>
        <Typography variant="h6">Firma (Eigentümer)</Typography>
        <Box mt={2} />
        <Grid container spacing={2}>
          <Grid size={6}>
            <TextField
              required
              fullWidth
              label="Firmenname"
              value={project.company.name}
              error={project.company.name === ""}
              onChange={e => handleCompanyChange("name", e.target.value)}
            />
          </Grid>
          <Grid size={6}>
            <TextField
              required
              fullWidth
              label="Straße und Hausnummer"
              value={project.company.street}
              error={project.company.street === ""}
              onChange={e => handleCompanyChange("street", e.target.value)}
            />
          </Grid>
          <Grid size={6}>
            <TextField
              required
              fullWidth
              label="Postleitzahl und Ort"
              value={project.company.city}
              error={project.company.city === ""}
              onChange={e => handleCompanyChange("city", e.target.value)}
            />
          </Grid>
          <Grid size={6}>
            <TextField
              required
              fullWidth
              label="Land"
              value={project.company.country}
              error={project.company.country === ""}
              onChange={e => handleCompanyChange("country", e.target.value)}
            />
          </Grid>
        </Grid>
      </Paper>
    </PageLayout>
  );
};

export default ProjectPage;
